<header class="header">
	<figure>
		<img src="assets/logos/logo_towerbank.svg" alt="Logotipo Towerbank" />
	</figure>
</header>